import React from 'react';
import { string } from 'prop-types';
import {
  FooterBackTop,
  FooterCenter,
  FooterContainer,
  FooterDivider,
  FooterGrid,
  FooterIconLink,
  FooterImage,
  FooterLeft,
  FooterMadeWith,
  FooterRight,
  FooterTextLink,
} from './Footer.styles';
import { CONTACT_LINKS, getSupportMailto } from '../config/contactLinks';
import { REQUEST_PREMIERE_URL } from '../config/primaryLinks';

const INSTAGRAM_LOGO_URL = '/instagram-logo-thin.svg';

function Footer({ logoPath }) {
  return (
    <FooterContainer>
      <FooterGrid>
        <FooterLeft>
          <FooterMadeWith>Made with love by</FooterMadeWith>
          {logoPath ? (
            <FooterImage
              src={logoPath}
              alt="Veeflix"
              width={180}
            />
          ) : (
            <span>VEEFLIX</span>
          )}
        </FooterLeft>

        <FooterCenter>
          Veeflix is a private digital memory experience. Not affiliated with Netflix or any streaming platform. &copy; 2026 Veeflix.
        </FooterCenter>

        <FooterRight>
          <FooterTextLink href={REQUEST_PREMIERE_URL} target="_blank" rel="noreferrer">Gift a Flix</FooterTextLink>
          <FooterDivider>|</FooterDivider>
          <FooterTextLink href={getSupportMailto()}>Need Help?</FooterTextLink>
          <FooterDivider>|</FooterDivider>
          <FooterIconLink href={getSupportMailto()} aria-label="Email support">
            <img src="https://unpkg.com/lucide-static@0.469.0/icons/mail.svg" alt="" />
          </FooterIconLink>
          <FooterIconLink href={REQUEST_PREMIERE_URL} target="_blank" rel="noreferrer" aria-label="WhatsApp">
            <img src="https://unpkg.com/lucide-static@0.469.0/icons/message-circle.svg" alt="" />
          </FooterIconLink>
          <FooterIconLink href={CONTACT_LINKS.dmUrl} target="_blank" rel="noreferrer" aria-label="Instagram">
            <img src={INSTAGRAM_LOGO_URL} alt="" />
          </FooterIconLink>
          <FooterBackTop
            type="button"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <span aria-hidden="true">↑</span>
          </FooterBackTop>
        </FooterRight>
      </FooterGrid>
    </FooterContainer>
  );
}

export default Footer;

Footer.propTypes = {
  logoPath: string,
};
